export const PLAN_ACTIONS = {
  UPGRADE: "upgrade",
  DOWNGRADE: "downgrade",
  INTERVAL_UPGRADE: "interval_upgrade",
  INTERVAL_DOWNGRADE: "interval_downgrade",
  SCHEDULED_INTERVAL_DOWNGRADE: "scheduled_interval_downgrade",
} as const;

export type PlanActionType = (typeof PLAN_ACTIONS)[keyof typeof PLAN_ACTIONS];

const isUpgrade = (planAction?: string): boolean =>
  planAction === PLAN_ACTIONS.UPGRADE;

export const isDowngrade = (planAction?: string): boolean =>
  planAction === PLAN_ACTIONS.DOWNGRADE;

const isIntervalUpgrade = (planAction?: string): boolean =>
  planAction === PLAN_ACTIONS.INTERVAL_UPGRADE;

export const isIntervalDowngrade = (planAction?: string): boolean =>
  planAction === PLAN_ACTIONS.INTERVAL_DOWNGRADE;

export const isAnyUpgrade = (planAction?: string): boolean =>
  isUpgrade(planAction) || isIntervalUpgrade(planAction);
